import React from "react";
import { Route, Routes } from "react-router-dom";
import AddProductForm from "../components/AddProduct/App";
import AllThreeDModels from "../components/AllThreeDModels/App";
import InterestedForm from "./InterestedForm";
import { ProductDetails } from "./ProductDetails";
import App from "../components/AllThreeDModels/App";
import Navbar from "./Navbar";
import HomePage from "../components/HomePage/App";
import Footer from "./Footer";

const Root = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route>
          {/* Frontend Ui */}

          <Route path="/" element={<HomePage />} />
          <Route path="/old" element={<AllThreeDModels />} />
          <Route path="/home" element={<App />} />
          <Route path="/product/:productId" element={<ProductDetails />} />
          <Route path="/contact-us" element={<InterestedForm />} />
          <Route path="/addProduct" element={<AddProductForm />} />
          {/* Backend Ui */}
        </Route>
      </Routes>
      <Footer/>
    </>
  );
};

export default Root;
